const PermissionDenied = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-red-500">403</h1>
        <h2 className="mt-4 text-2xl font-semibold text-gray-800">
          Access Denied
        </h2>
        <p className="mt-2 text-gray-600">
          Sorry, you don’t have permission to access this page.
        </p>
      </div>
    </div>
  );
};

export default PermissionDenied;
